import React, { Component, useContext } from "react";
import { useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import { ChevronDownIcon } from "@heroicons/react/solid";
import ContactProfile from "./ContactProfile";
import { withTranslation } from "react-i18next";
import "./Style.css";
import Editcontact from "./Editcontact";
import DeleteContact from "./Deletecontact";
//import CollegueProfile from "./CollegueProfile"
// import Contactlist from "./ Contactlist"
import ReactTooltip from "react-tooltip";

import axios from "axios";
import { Context } from "../../themeContext";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const token = localStorage.getItem("AccessToken");
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const BackendURL = window.BackendURLCmk;
function Contactbox(props) {
  const { t, tReady } = props;
  const [showModal, setShow] = useState(false);
  const [stateObject, dispatch] = useContext(Context);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showModal2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [showResults, setShowResults] = useState(false);

  const [showMoprofile, setshowprofile] = useState(false);
  const setshowprofilefunction = () => {
    setshowprofile(true);
  };
  const sethideprofilefunction = () => {
    setshowprofile(false);
  };

  const onClick = () => {
    if (showResults == true) {
      setShowResults(false);
    }
    if (showResults == false) {
      setShowResults(true);
    }
  };
  const upper = (nom) => {
    return nom.toUpperCase();
  };
  const Results = (num) => (
    <div
      style={{ zIndex: "9999" }}
      className="origin-top-right absolute  -ml-8 w-rounded-full  shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
    >
      <ul class="divide-y divide-gray-200">
        <li class="">
          <a href="#" class="block py-2 pl-8 pr-4 bg-white hover:bg-gray-50">
            <span class="block text-sm text-gray-900">mobile 1</span>
            <span class="block text-sm text-gray-500  font-medium">
              {num.num.tel_3}
            </span>
          </a>
        </li>
        <li class="">
          <a href="#" class="block py-2 pl-8 pr-4 bg-white hover:bg-gray-50">
            <span class="block text-sm text-gray-900">mobile 2</span>
            <span class="block text-sm text-gray-500  font-medium">
              {num.num.tel_4}
            </span>
          </a>
        </li>
        <li class="">
          <a href="#" class="block py-2 pl-8 pr-4 bg-white hover:bg-gray-50">
            <span class="block text-sm text-gray-900">mobile 3</span>
            <span class="block text-sm text-gray-500  font-medium">
              {num.num.tel_5}
            </span>
          </a>
        </li>
      </ul>
    </div>
  );
  const icondelte = (type) => {
    if (type !== "tel_externe") {
      return (
        <button
          data-tip
          data-for="delTip"
          type="button"
          onClick={handleShow2}
          className="dark:bg-gray-600 inline-flex justify-between mr-2 items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          <ReactTooltip id="delTip" place="bottom" effect="solid">
            {t("delete")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-400 dark:text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
        </button>
      );
    }
  };
  const iconedit = (type) => {
    if (type == "tel_externe") {
      //  return console.log("tel externe");
    } else {
      return (
        <button
          data-tip
          data-for="editTip"
          type="button"
          onClick={handleShow}
          className="dark:bg-gray-600 inline-flex justify-between mr-2 items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none"
        >
          <ReactTooltip id="editTip" place="bottom" effect="solid">
            {t("edit")}
          </ReactTooltip>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-gray-400 dark:text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
            />
          </svg>
        </button>
      );
    }
  };

  return (
    <tr className="dark:bg-gray-900 dark:text-white transition-al">
      <td class=" border-b border-gray-200 dark:border-gray-700">
        {/* <div>{ project(person.disposition) }</div> */}
        <div class=" px-2 flex-shrink-0">
          <span class="dark:bg-gray-700 inline-flex items-center justify-center h-12 w-12 rounded-full bg-gray-400">
            <span class=" text-lg font-medium leading-none text-white ">
              {props.contact.nom_prenom && upper(props.contact.nom_prenom[0])}
            </span>
          </span>
          <ReactTooltip id="callTip" place="bottom" effect="solid">
            {t("Appeler")}{" "}
          </ReactTooltip>

          {/* <img class="h-12 w-12 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt=""/> */}
        </div>
      </td>
      <td class=" whitespace-no-wrap border-b border-gray-200 dark:border-gray-700 ">
        <div class="ml-4 dark:text-white">{props.contact.nom_prenom}</div>
      </td>
      <td class=" whitespace-no-wrap border-b border-gray-200 dark:border-gray-700 ">
        <div class="ml-4 dark:text-white">{props.contact.prenom}</div>
      </td>
      <td class="px-2 py-3 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        {/* <span class="text-sm leading-5 text-gray-900">13 Mars 2021</span>
                    <div class="text-sm leading-5 text-gray-500 ml-2 inline-block">à 14:20</div> */}
        <div className="dark:bg-gray-700  w-44 flex py-3 items-center justify-center border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-500 bg-gray-100 hover:bg-gray-300 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-500 sm:flex-auto">
          {/* //class=" text-gray-500 bg-gray-300 shadow-sm ml-2 inline-block flex
          border border-transparent rounded-md shadow-sm bg-white"> //
          className="inline-block bg-gray-100 border border-transparent
          rounded-md shadow-sm px-4 py-2" */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mt-0.5 mr-2 text-green-500 text-left"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
            />
          </svg>
          <button
            type="button"
            className=" text-gray-600 dark:text-white"
            onClick={() =>
              dispatch({
                type: "MAKE_CALL",
                payload: {
                  number: props.contact.tel_portable,
                  type: "CALL",
                  nom: props.contact.nom_prenom,
                  image: "",
                },
              })
            }
            //className=" items-center justify-center border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-500 bg-white hover:bg-gray-300 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-green-500 sm:flex-auto"
          >
            {props.contact.tel_portable}
          </button>
          {/* <ReactTooltip id="infoTip" place="bottom" effect="solid">
            Autres Numéros
          </ReactTooltip> */}
          {props.contact.tel_3 ||
          props.contact.tel_4 ||
          props.contact.tel_5 ||
          props.contact.tel_fix ? (
            <span className="ml-3 inline-flex sm:ml-0 pt-2">
              <Menu as="div" className="relative inline-block text-left">
                {({ open }) => (
                  <>
                    <Menu.Button
                      class="items-center justify-center"
                      //className="inline-flex items-center p-2 shadow-sm text-sm font-medium text-gray-400 bg-white hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-gray-300">
                    >
                      <ChevronDownIcon
                        className="h-5 w-5 ml-4 text-gray-600"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                    <Transition
                      show={open}
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      {props.contact.tel_3 ||
                      props.contact.tel_4 ||
                      props.contact.tel_5 ||
                      props.contact.tel_fix ? (
                        <Menu.Items
                          static
                          className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                          style={{ zIndex: "9999" }}
                        >
                          <div className="py-1">
                            {props.contact.tel_fix ? (
                              <Menu.Item>
                                <button
                                  type="button"
                                  className=" block px-4 py-2 text-sm text-gray-500"
                                  onClick={() =>
                                    dispatch({
                                      type: "MAKE_CALL",
                                      payload: {
                                        number: props.contact.tel_fix,
                                        type: "CALL",
                                        nom: props.contact.nom_prenom,
                                        image: "",
                                      },
                                    })
                                  }
                                >
                                  <span className="font-bold">
                                    {" "}
                                    {t("tel")} 2:
                                  </span>{" "}
                                  {props.contact.tel_fix}
                                </button>
                              </Menu.Item>
                            ) : (
                              <div></div>
                            )}
                            {props.contact.tel_3 ? (
                              <Menu.Item>
                                <button
                                  type="button"
                                  className=" block px-4 py-2 text-sm text-gray-500 text-bold"
                                  onClick={() =>
                                    dispatch({
                                      type: "MAKE_CALL",
                                      payload: {
                                        number: props.contact.tel_3,
                                        type: "CALL",
                                        nom: props.contact.nom_prenom,
                                        image: "",
                                      },
                                    })
                                  }
                                >
                                  <span className="font-bold">
                                    {" "}
                                    {t("tel")} 3 :
                                  </span>{" "}
                                  {props.contact.tel_3}
                                </button>
                              </Menu.Item>
                            ) : (
                              <div></div>
                            )}
                            {props.contact.tel_4 ? (
                              <Menu.Item>
                                <button
                                  type="button"
                                  className=" block px-4 py-2 text-sm text-gray-500"
                                  onClick={() =>
                                    dispatch({
                                      type: "MAKE_CALL",
                                      payload: {
                                        number: props.contact.tel_4,
                                        type: "CALL",
                                        nom: props.contact.nom_prenom,
                                        image: "",
                                      },
                                    })
                                  }
                                >
                                  <span className="font-bold">
                                    {t("tel")} 4 :
                                  </span>{" "}
                                  {props.contact.tel_4}
                                </button>
                              </Menu.Item>
                            ) : (
                              <div></div>
                            )}
                            {props.contact.tel_5 ? (
                              <Menu.Item>
                                <button
                                  type="button"
                                  className=" block px-4 py-2 text-sm text-gray-500"
                                  onClick={() =>
                                    dispatch({
                                      type: "MAKE_CALL",
                                      payload: {
                                        number: props.contact.tel_5,
                                        type: "CALL",
                                        nom: props.contact.nom_prenom,
                                        image: "",
                                      },
                                    })
                                  }
                                >
                                  <span className="font-bold">
                                    {" "}
                                    {t("tel")} 5 :
                                  </span>{" "}
                                  {props.contact.tel_5}
                                </button>
                              </Menu.Item>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        </Menu.Items>
                      ) : (
                        <Menu.Items
                          static
                          className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                          style={{ zIndex: "9999" }}
                        >
                          <div className="py-1">
                            <Menu.Item>
                              <a
                                href="#"
                                className={classNames(
                                  props.contact.tel_fix
                                    ? "bg-gray-100 text-gray-900"
                                    : "text-gray-700",
                                  "block px-4 py-2 text-sm"
                                )}
                              >
                                Pas de numéro
                              </a>
                            </Menu.Item>
                          </div>
                        </Menu.Items>
                      )}
                    </Transition>
                  </>
                )}
              </Menu>
            </span>
          ) : (
            <div></div>
          )}
        </div>
      </td>
      <td class="px-2 py-3 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <span class="text-sm leading-5 text-gray-500 ml-2 inline-block dark:text-white">
          {/* {props.person.billsec} */}
          {props.contact.adresse}
        </span>
      </td>
      <td class="px-2 py-3 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 dark:border-gray-700 font-medium">
        <div class="flex space-x-3">
          {/* {(props.contact.)} */}
          {/* <button
            data-tip
            data-for="callTip"
            type="button"
            onClick={() => call(props.contact.tel_portable)}
            className="inline-flex justify-between mr-2 items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
          </button> */}
          <div>
            <ReactTooltip id="infoTip" place="bottom" effect="solid">
              {t("contactprofil")}
            </ReactTooltip>

            <button
              data-tip
              data-for="infoTip"
              type="button"
              onClick={setshowprofilefunction}
              className="dark:bg-gray-600 inline-flex items-center p-2 border rounded-full border-transparent shadow-sm text-xs font-medium text-gray-500 bg-gray-100 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 dark:text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </button>
            <ContactProfile
              show={showMoprofile}
              close={sethideprofilefunction}
              collegue={props.contact}
            />
            {showResults ? <Results num={props.contact} /> : null}
          </div>
          {icondelte(props.contact.type_contact)}
          <DeleteContact
            showModal={showModal2}
            handleClose={handleClose2}
            id={props.contact.id}
            toggle={props.toggle}
          />
          {iconedit(props.contact.type_contact)}
          {/* {console.log("this is contact", props.contact)} */}
          <Editcontact
            showModal={showModal}
            handleClose={handleClose}
            contact={props.contact}
            toggle={props.toggle}
          />
        </div>
      </td>
    </tr>
  );
}
export default withTranslation("common")(Contactbox);
